import { cn } from "@/lib/utils";

export type FileKind = "table" | "plan" | "document" | "archive" | "image" | "other";

const KINDS: Record<string, FileKind> = {
  csv: "table", xlsx: "table", xls: "table", txt: "table",
  dwg: "plan", dxf: "plan",
  pdf: "document",
  zip: "archive",
  png: "image", jpg: "image", jpeg: "image", webp: "image",
};

export const fileKindOf = (name: string): FileKind => {
  const dot = name.lastIndexOf(".");
  return KINDS[dot < 0 ? "" : name.slice(dot + 1).toLowerCase()] ?? "other";
};

/**
 * A file's icon in the hairline stroke: a sheet whose corner is folded, and inside it what the type
 * stands for (rows, a plan, lines of text, a zip, a picture). The lines draw themselves once.
 */
export default function FileTypeIcon({ name, className, drawn = true }: { name: string; className?: string; drawn?: boolean }) {
  const kind = fileKindOf(name);
  const line = (d: string, delay: number) => (
    <path d={d} pathLength={1} className={cn(drawn && "onb-line-play")} style={{ ["--onb-delay" as string]: `${delay}ms` }} />
  );
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className={cn("h-6 w-6 shrink-0", className)} fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" data-kind={kind}>
      {line("M6 3h8l4 4v14H6z", 0)}
      {line("M14 3v4h4", 160)}
      {kind === "table" && (<>{line("M9 11h6", 260)}{line("M9 14h6", 320)}{line("M9 17h6", 380)}{line("M12 10v8", 440)}</>)}
      {kind === "plan" && (<>{line("M9 10h6v7H9z", 260)}{line("M12 10v3h3", 340)}{line("M9 14h2", 420)}</>)}
      {kind === "document" && (<>{line("M9 11h6", 260)}{line("M9 14h6", 320)}{line("M9 17h4", 380)}</>)}
      {kind === "archive" && (<>{line("M12 8v2M12 11v2M12 14v2", 260)}{line("M10.5 17h3v2h-3z", 360)}</>)}
      {kind === "image" && (<>{line("M9 17l2.5-3 2 2 1.5-2 2 3", 260)}{line("M10 11.2h.01", 340)}</>)}
      {kind === "other" && line("M9 12h6M9 15h6", 260)}
    </svg>
  );
}
